import { Component, OnInit } from '@angular/core';
import { MechanicsApi } from "../../shared/sdk/services";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-descargas-pdf-xml',
  templateUrl: './descargas-pdf-xml.component.html',
  styleUrls: ['./descargas-pdf-xml.component.scss']
})
export class DescargasPdfXmlComponent implements OnInit {
  uuid;

  constructor(
    private route: ActivatedRoute,
    private mechanicsApi: MechanicsApi
  ) {
    this.uuid = this.route.snapshot.paramMap.get("uuid");
  }

  ngOnInit() { }

  descargaXML() {
    this.mechanicsApi.generaDescargaXml(this.uuid).subscribe((xml) => {
      let elem = document.getElementById('download');
      elem.setAttribute('href', 'data:application/xml;charset=utf-8,' + encodeURIComponent(xml));
      elem.click();
    });
  }

}
